import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import ScheduleCalendar from "@/components/ScheduleCalendar";
import ScheduleTabs, { useTabParam } from "@/components/ScheduleTabs";
import MemberAttendanceHistory from "@/pages/member/AttendanceHistory";
import ChildVolunteerShifts from "@/components/ChildVolunteerShifts";
import { useFeatureFlags, FeatureDisabled } from "@/lib/featureFlags";

export default function ParentStudentSchedule() {
  const { schedule: scheduleOn } = useFeatureFlags();
  const { id } = useParams();
  const [items, setItems] = useState([]);
  const [attendance, setAttendance] = useState(null);
  const [volunteers, setVolunteers] = useState(null);
  const tabs = [{ key: "calendar", label: "Calendar" }, attendance?.enabled && { key: "attendance", label: "Attendance" },
    volunteers?.enabled && { key: "volunteer", label: "Volunteer" }].filter(Boolean);
  const [tab, setTab] = useTabParam(tabs.map((t) => t.key));

  useEffect(() => {
    api.get(`/parent/students/${id}/schedule`).then(({ data }) => setItems(data.items || [])).catch(() => {});
    api.get(`/parent/students/${id}/attendance`).then(({ data }) => setAttendance(data)).catch(() => setAttendance({ enabled: false }));
    api.get(`/parent/students/${id}/volunteers`).then(({ data }) => setVolunteers(data)).catch(() => setVolunteers({ enabled: false }));
  }, [id]);

  if (!scheduleOn) return <FeatureDisabled name="Daily Schedule" />;
  const marks = Object.fromEntries((attendance?.records || []).map((r) => [r.event_id, r.status]));

  return (
    <div data-testid="parent-student-schedule">
      <p className="mb-4 text-sm text-slate-500">Team events, volunteer sign-ups and scheduled conferences — the same schedule your student sees.</p>
      <ScheduleTabs tabs={tabs} value={tab} onChange={setTab} />
      {tab === "attendance" && <MemberAttendanceHistory records={attendance.records || []} />}
      {tab === "volunteer" && <ChildVolunteerShifts data={volunteers} />}
      {tab === "calendar" && <ScheduleCalendar items={items} attendanceFor={(eid) => marks[eid]} />}
    </div>
  );
}
